<a
                href="{{ url | async }}"
                target="_blank"
                class="fab fa-twitter"></a>